
<form [formGroup]="axisEightDoubleLeftIntForm">
    <div class="form-row">
        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
              <mat-label>Posição Pneu</mat-label>
              <input formControlName="cdPosicaoPneu"  placeholder="Posição Pneu" matInput [readonly]=true [disabled]=true/>
            </mat-form-field>
        </div>

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
                    <mat-label>Pneu(nr de fogo)</mat-label>
                    <input  formControlName="pneu"  
                    placeholder="Número de fogo" matInput [readonly]=true [disabled]=true/>
            </mat-form-field>
        </div>

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
              <mat-label>Sensor</mat-label>
              <mat-select formControlName="cdSensor" [(value)]="sensorEightIntLeftSelect" [(ngModel)]="sensorEightIntLeftSelect" [readonly]=true [disabled]=true>
                <mat-option *ngFor="let type of sensorEightIntLeftCombo" [value]="type.id">
                  {{ type.codigoSensor }}
                </mat-option>
              </mat-select>
            </mat-form-field>
        </div>

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
                    <mat-label>Pressão Min (PSI)</mat-label>
                <input required formControlName="nrPressaoMinima" pattern="[0-9]*" matInput [readonly]=true [disabled]=true
                 placeholder="Pressão Min (PSI)" (keypress)="numberOnly($event)" />
            </mat-form-field>
        </div>

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
                    <mat-label>Pressão Máx (PSI)*</mat-label>
                <input required formControlName="nrPressaoMaxima" pattern="[0-9]*" matInput [readonly]=true [disabled]=true
                placeholder="Pressão Max (PSI)" (keypress)="numberOnly($event)" />
            </mat-form-field>
        </div>

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
                    <mat-label>Temp. Máx (°C)*</mat-label>
                <input required formControlName="nrTemperaturaMaxima" required pattern="[0-9]*"  matInput [readonly]=true [disabled]=true
                placeholder="Temp. Máx (°C)" (keypress)="numberOnly($event)" />
            </mat-form-field>
        </div>
    </div>
</form>
<form [formGroup]="axisEightDoubleLeftExtForm">
            <div class="form-row">

                <div class="form-group col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Posição Pneu</mat-label>
                      <input formControlName="cdPosicaoPneu"  placeholder="Posição Pneu" matInput [readonly]=true [disabled]=true/>
                    </mat-form-field>
                </div>
        
                <div class="form-group col-lg-2">
                    <mat-form-field appearance="outline">
                            <mat-label>Pneu(nr de fogo)</mat-label>
                            <input  formControlName="pneu"  
                            placeholder="Número de fogo" matInput [readonly]=true [disabled]=true/>
                    </mat-form-field>
                </div>
        
                <div class="form-group col-lg-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Sensor</mat-label>
                      <mat-select formControlName="cdSensor" [(value)]="sensorEightExtLeftSelect" [(ngModel)]="sensorEightExtLeftSelect" [readonly]=true [disabled]=true>
                        <mat-option *ngFor="let type of sensorEightExtLeftCombo" [value]="type.id">
                          {{ type.codigoSensor }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>
        
                <div class="form-group col-lg-2">
                    <mat-form-field appearance="outline">
                            <mat-label>Pressão Min (PSI)</mat-label>
                        <input required formControlName="nrPressaoMinima" pattern="[0-9]*" matInput [readonly]=true [disabled]=true
                         placeholder="Pressão Min (PSI)" (keypress)="numberOnly($event)" />
                    </mat-form-field>
                </div>
        
                <div class="form-group col-lg-2">
                    <mat-form-field appearance="outline">
                            <mat-label>Pressão Máx (PSI)*</mat-label>
                        <input required formControlName="nrPressaoMaxima" pattern="[0-9]*" matInput [readonly]=true [disabled]=true
                        placeholder="Pressão Max (PSI)" (keypress)="numberOnly($event)" />
                    </mat-form-field>
                </div>
        
                <div class="form-group col-lg-2">
                    <mat-form-field appearance="outline">
                            <mat-label>Temp. Máx (°C)*</mat-label>
                        <input required formControlName="nrTemperaturaMaxima" required pattern="[0-9]*"  matInput [readonly]=true [disabled]=true
                        placeholder="Temp. Máx (°C)" (keypress)="numberOnly($event)" />
                    </mat-form-field>
                </div>
            </div>
    </form>

    <form [formGroup]="axisEightDoubleRightIntForm">
        <div class="form-row">

            <div class="form-group col-lg-2">
                <mat-form-field appearance="outline">
                  <mat-label>Posição Pneu</mat-label>
                  <input formControlName="cdPosicaoPneu"  placeholder="Posição Pneu" matInput [readonly]=true [disabled]=true/>
                </mat-form-field>
            </div>
    
            <div class="form-group col-lg-2">
                <mat-form-field appearance="outline">
                        <mat-label>Pneu(nr de fogo)</mat-label>
                        <input  formControlName="pneu"  
                        placeholder="Número de fogo" matInput [readonly]=true [disabled]=true/>
                </mat-form-field>
            </div>
    
            <div class="form-group col-lg-2">
                <mat-form-field appearance="outline">
                  <mat-label>Sensor</mat-label>
                  <mat-select formControlName="cdSensor" [(value)]="sensorEightIntRightSelect" [(ngModel)]="sensorEightIntRightSelect" [readonly]=true [disabled]=true>
                    <mat-option *ngFor="let type of sensorEightIntRightCombo" [value]="type.id">
                      {{ type.codigoSensor }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
            </div>
    
            <div class="form-group col-lg-2">
                <mat-form-field appearance="outline">
                        <mat-label>Pressão Min (PSI)</mat-label>
                    <input required formControlName="nrPressaoMinima" pattern="[0-9]*" matInput [readonly]=true [disabled]=true
                     placeholder="Pressão Min (PSI)" (keypress)="numberOnly($event)" />
                </mat-form-field>
            </div>
    
            <div class="form-group col-lg-2">
                <mat-form-field appearance="outline">
                        <mat-label>Pressão Máx (PSI)*</mat-label>
                    <input required formControlName="nrPressaoMaxima" pattern="[0-9]*" matInput [readonly]=true [disabled]=true
                    placeholder="Pressão Max (PSI)" (keypress)="numberOnly($event)" />
                </mat-form-field>
            </div>
    
            <div class="form-group col-lg-2">
                <mat-form-field appearance="outline">
                        <mat-label>Temp. Máx (°C)*</mat-label>
                    <input required formControlName="nrTemperaturaMaxima" required pattern="[0-9]*"  matInput [readonly]=true [disabled]=true
                    placeholder="Temp. Máx (°C)" (keypress)="numberOnly($event)" />
                </mat-form-field>
            </div>
        </div>
</form>

<form [formGroup]="axisEightDoubleRightExtForm">
    <div class="form-row">

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
              <mat-label>Posição Pneu</mat-label>
              <input formControlName="cdPosicaoPneu"  placeholder="Posição Pneu" matInput [readonly]=true [disabled]=true/>
            </mat-form-field>
        </div>

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
                    <mat-label>Pneu(nr de fogo)</mat-label>
                    <input  formControlName="pneu"  
                    placeholder="Número de fogo" matInput [readonly]=true [disabled]=true/>
            </mat-form-field>
        </div>

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
              <mat-label>Sensor</mat-label>
              <mat-select formControlName="cdSensor" [(value)]="sensorEightExtRightSelect" [(ngModel)]="sensorEightExtRightSelect" [readonly]=true [disabled]=true>
                <mat-option *ngFor="let type of sensorEightExtRightCombo" [value]="type.id">
                  {{ type.codigoSensor }}
                </mat-option>
              </mat-select>
            </mat-form-field>
        </div>

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
                    <mat-label>Pressão Min (PSI)</mat-label>
                <input required formControlName="nrPressaoMinima" pattern="[0-9]*" matInput [readonly]=true [disabled]=true
                 placeholder="Pressão Min (PSI)" (keypress)="numberOnly($event)" />
            </mat-form-field>
        </div>

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
                    <mat-label>Pressão Máx (PSI)*</mat-label>
                <input required formControlName="nrPressaoMaxima" pattern="[0-9]*" matInput [readonly]=true [disabled]=true
                placeholder="Pressão Max (PSI)" (keypress)="numberOnly($event)" />
            </mat-form-field>
        </div>

        <div class="form-group col-lg-2">
            <mat-form-field appearance="outline">
                    <mat-label>Temp. Máx (°C)*</mat-label>
                <input required formControlName="nrTemperaturaMaxima" required pattern="[0-9]*"  matInput [readonly]=true [disabled]=true
                placeholder="Temp. Máx (°C)" (keypress)="numberOnly($event)" />
            </mat-form-field>
        </div>
    </div>
</form>